/** Normalize org/user plan codes for display (defaults missing values to FREE). */
export function normalizePlanType(plan?: string | null): string {
  const trimmed = (plan ?? '').trim();
  if (!trimmed) return 'FREE';
  const upper = trimmed.toUpperCase();
  if (upper === 'FREE TIER' || upper === 'FREETIER') return 'FREE';
  return upper;
}

/** User-facing plan label for profile chips and menus. */
export function formatPlanDisplayLabel(plan?: string | null): string {
  return normalizePlanType(plan);
}

export function isFreePlan(plan?: string | null): boolean {
  return normalizePlanType(plan) === 'FREE';
}

type PlanChipOptions = {
  /** Chip sits on a dark profile hero background */
  onDarkBackground?: boolean;
};

/** Consistent chip colors: FREE = neutral slate, paid = teal accent. */
export function getPlanChipSx(plan?: string | null, options?: PlanChipOptions) {
  const normalized = normalizePlanType(plan);
  const onDark = options?.onDarkBackground ?? false;

  if (normalized === 'FREE') {
    return onDark
      ? {
          bgcolor: 'rgba(255, 255, 255, 0.22)',
          color: '#ffffff',
          border: '1px solid rgba(255, 255, 255, 0.35)',
        }
      : {
          bgcolor: 'rgba(100, 116, 139, 0.12)',
          color: '#475569',
          border: '1px solid rgba(100, 116, 139, 0.35)',
        };
  }

  return onDark
    ? {
        bgcolor: 'rgba(255, 255, 255, 0.22)',
        color: '#ffffff',
        border: '1px solid rgba(255, 255, 255, 0.35)',
      }
    : {
        bgcolor: '#0f766e',
        color: '#ffffff',
        border: '1px solid rgba(15, 118, 110, 0.5)',
      };
}

/** Resolve plan from user auth snapshot and optional tenant organization. */
export function resolveUserPlanType(
  userPlan?: string | null,
  organizationPlan?: string | null,
): string {
  const userNorm = (userPlan ?? '').trim();
  if (userNorm) return normalizePlanType(userNorm);
  return normalizePlanType(organizationPlan);
}
